var layout = require('./layout');

module.exports = Mario.ItemView.extend({
    template: layout
});
